<div class="div-input">
  <tds-text-field
    [type]="type"
    [value]="value"
    [size]="size"
    state="default"
    [label]="label"
    label-position="inside"
    no-min-width="true"
    min="0"
    [placeholder]="placeholder"
    [maxLength]="maxLength"
    [readOnly]="readOnly"
    [disabled]="disabled"
    (tdsInput)="handleInput($event)"
    (tdsBlur)="onTouched()"
  ></tds-text-field>
</div>
